import { render, staticRenderFns } from "./MomentCard.vue?vue&type=template&id=4383f87e&scoped=true"
import script from "./MomentCard.vue?vue&type=script&lang=ts"
export * from "./MomentCard.vue?vue&type=script&lang=ts"
import style0 from "./MomentCard.vue?vue&type=style&index=0&id=4383f87e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4383f87e",
  null
  
)

export default component.exports